import React from 'react'
import {FormGroup, FormControl} from 'react-bootstrap'

const RenderSelect = (props) => {
  const {input, options} = props;
  return (
    <FormGroup>
      <FormControl
          componentClass="select" placeholder="select" title={props.title}
          {...input}
      >
          {options.map((option) => (
            <option key={`team-${option.id}`} value={option.id}>{option.name}</option>
          ))}
      </FormControl>
    </FormGroup>
  )
}

export default RenderSelect


// WEBPACK FOOTER //
// ./src/reports/general/javascripts/components/User/FormFields/RenderSelect.jsx